/**
 * Modal de vídeos da PDP (spec 0075).
 * Thumbs [data-gm-video-open] abrem <dialog data-gm-video-dialog>.
 */
(() => {
  const openers = document.querySelectorAll('[data-gm-video-open]');
  if (!openers.length) return;

  const dialog = document.querySelector('[data-gm-video-dialog]');
  if (!dialog) return;

  const frame = dialog.querySelector('[data-gm-video-frame]');
  const closeBtn = dialog.querySelector('[data-gm-video-close]');

  const clearFrame = () => {
    if (frame) frame.replaceChildren();
  };

  const closeDialog = () => {
    clearFrame();
    dialog.classList.remove('gm-pdp-video-dialog--portrait');
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  };

  const openDialog = (kind, src, ratio) => {
    if (!frame || !src) return;
    clearFrame();
    dialog.classList.toggle('gm-pdp-video-dialog--portrait', ratio === 'portrait');

    if (kind === 'file') {
      const video = document.createElement('video');
      video.src = src;
      video.controls = true;
      video.autoplay = true;
      video.playsInline = true;
      video.className = 'gm-pdp-video-dialog__media';
      frame.appendChild(video);
    } else {
      const iframe = document.createElement('iframe');
      iframe.src = src;
      iframe.title = 'Vídeo do produto';
      iframe.allow =
        'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      iframe.allowFullscreen = true;
      iframe.className = 'gm-pdp-video-dialog__media';
      frame.appendChild(iframe);
    }

    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
  };

  openers.forEach((btn) => {
    btn.addEventListener('click', () => {
      openDialog(
        btn.getAttribute('data-gm-video-kind') || 'url',
        btn.getAttribute('data-gm-video-src'),
        btn.getAttribute('data-gm-video-ratio') || 'landscape'
      );
    });
  });

  closeBtn?.addEventListener('click', closeDialog);

  dialog.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });

  dialog.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeDialog();
  });
})();
